export class Role {
    roleID: number;
    roleName: string;
    roleDescription: string;
    isOrgRequired: boolean;
}
